import React from 'react';
import BootingIcon, { getVariantDefinition } from './BootingIcon';
import styles from './BootingValue.module.css';
import clsx from 'clsx';

export type BootingValueVariant = 'transactions' | 'thinkTime' | 'noMatchingBehaviour' | 'ssl' | 'blazeData';

interface BootingValueProps {
  variant: BootingValueVariant;
  value: string | number;
  title: string | number | Element;
  showSeparator: boolean;
}

const BootingValue = ({ value, title, variant, showSeparator }: BootingValueProps) => {
  const variantDef = getVariantDefinition(variant);

  return (
    <div className={clsx('d-flex', showSeparator && styles.separator, 'p-2', 'px-5')}>
      <div className={'mr-4'}>
        <BootingIcon variant={variant} />
      </div>
      <div className={'mt-2 text-truncate'}>
        <span className={styles.value} style={{ color: variantDef.color }}>
          {value}
        </span>
        <span>{title}</span>
      </div>
    </div>
  );
};

export default BootingValue;
